import { Button, Flex, Input, Text } from '@nula/core-ui';
import styles from './name-step.module.css';

export interface NameStepProps {
  value: string;
  onChange: (v: string) => void;
  onContinue: () => void;
}

export function NameStep({ value, onChange, onContinue }: NameStepProps) {
  const isValid = value.trim().length > 0;

  function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter' && isValid) {
      onContinue();
    }
  }

  return (
    <Flex vertical gap="lg">
      <Flex vertical>
        <Text className={styles.eyebrow}>Welcome</Text>
        <Text className={styles.title}>
          Let&apos;s get you <em className={styles.titleEm}>settled in.</em>
        </Text>
        <Text type="secondary" className={styles.subtitle}>
          First, what should Nula call you? This shows up on your notes and shared spaces.
        </Text>
      </Flex>

      <Input
        label="Your name"
        size="lg"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        autoFocus
      />

      <Button variant="primary" size="lg" block disabled={!isValid} onClick={onContinue}>
        Continue
      </Button>
    </Flex>
  );
}
